import envConfig from '@hulu/env-config';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';

import { User } from './user';
import { HelpSiteCookieHelper } from './user/interfaces';

export async function rerouteToHubIfNeeded(cognitoUser: CognitoUser): Promise<void> {
  try {
    const session = cognitoUser.getSignInUserSession();
    const idToken = session?.getIdToken()?.getJwtToken();

    if (idToken && User.shouldRedirectToHub(idToken)) {
      await HelpSiteCookieHelper.setHelpSiteCookieForNonAdmin();
      window.location.href = envConfig.REACT_APP_REDIRECT_TO_HUB_URL;
    }
  } catch (err) {
    console.error('Error during rerouteToHubIfNeeded:', err);
  }
}

export async function rerouteToHubIfNeededWithAuth(): Promise<void> {
  try {
    const session = await Auth.currentSession();
    if (session && session.isValid()) {
      const idToken = session.getIdToken().getJwtToken();
      if (idToken && User.shouldRedirectToHub(idToken)) {
        await HelpSiteCookieHelper.setHelpSiteCookieForNonAdmin();
        window.location.href = envConfig.REACT_APP_REDIRECT_TO_HUB_URL;
      }
    }
  } catch (err) {
    console.error('Error during rerouteToHubIfNeededNew:', err);
  }
}
